/* =========================================================
   TOY STORE · JavaScript del tema
   ========================================================= */
(function () {
  'use strict';

  var theme = window.theme || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, cartType: 'drawer', moneyFormat: '${{amount}}' };

  /* ---------- Utilidades ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var fmt = theme.moneyFormat || '${{amount}}';
    function delimit(num, decimals, thousands, decimal) {
      var parts = (num / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delimit(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
        default: return delimit(cents, 2, ',', '.');
      }
    });
  }

  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 3200);
  }

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ---------- Cajones (menú y carrito) ---------- */
  var lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var focusable = $('[data-drawer-close]:not(.drawer__overlay)', drawer) || $('a,button', drawer);
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('drawer-open');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('aria-controls'));
      if (target) { e.preventDefault(); openDrawer(target); }
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('.drawer.is-open').forEach(closeDrawer);
      $$('details.filter[open]').forEach(function (d) { d.removeAttribute('open'); });
    }
  });

  /* ---------- Buscador del encabezado ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-search-toggle]');
    if (!btn) return;
    var panel = document.getElementById('SearchPanel');
    if (!panel) return;
    e.preventDefault();
    panel.hidden = !panel.hidden;
    btn.setAttribute('aria-expanded', String(!panel.hidden));
    if (!panel.hidden) { var input = $('input[type="search"]', panel); if (input) input.focus(); }
  });

  /* ---------- Encabezado fijo ---------- */
  var headerWrap = $('[data-header-wrap]');
  if (headerWrap) {
    var onScroll = function () { headerWrap.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Carrito ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  function refreshCart(open) {
    var url = theme.routes.cart + '?sections=cart-drawer';
    return Promise.all([
      fetch(url).then(function (r) { return r.json(); }),
      fetch(theme.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var html = res[0] && res[0]['cart-drawer'];
      var drawer = document.getElementById('CartDrawer');
      if (html && drawer) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = $('.drawer__panel', tmp);
        var current = $('.drawer__panel', drawer);
        if (fresh && current) current.replaceWith(fresh);
      }
      updateCount(res[1].item_count);
      if (open && drawer) openDrawer(drawer);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: res[1] }));
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (theme.cartType !== 'drawer' || !document.getElementById('CartDrawer')) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    var msg = $('[data-product-msg]', form.closest('[data-product]') || form);
    if (msg) msg.hidden = true;
    fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function () { return refreshCart(true); })
      .catch(function (err) {
        var text = (err && (err.description || err.message)) || 'No se pudo agregar al carrito. Intenta de nuevo.';
        if (msg) { msg.textContent = text; msg.hidden = false; } else { toast(text); }
      })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); } });
  });

  // Cambiar cantidades dentro del carrito lateral
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-qty]');
    if (!btn || !btn.closest('[data-cart-drawer]')) return;
    e.preventDefault();
    var line = parseInt(btn.getAttribute('data-line'), 10);
    var qty = parseInt(btn.getAttribute('data-line-qty'), 10);
    var item = btn.closest('.cart-item');
    if (item) item.style.opacity = '.5';
    postJSON(theme.routes.cartChange + '.js', { line: line, quantity: Math.max(0, qty) })
      .then(function () { return refreshCart(false); })
      .catch(function (err) { toast((err && err.description) || 'No se pudo actualizar el carrito.'); if (item) item.style.opacity = ''; });
  });

  // Página del carrito: actualiza al cambiar cantidad
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-page] input[data-line]');
    if (!input) return;
    var page = input.closest('[data-cart-page]');
    page.style.opacity = '.6';
    postJSON(theme.routes.cartChange + '.js', { line: parseInt(input.getAttribute('data-line'), 10), quantity: Math.max(0, parseInt(input.value, 10) || 0) })
      .then(function () { window.location.reload(); })
      .catch(function (err) { page.style.opacity = ''; toast((err && err.description) || 'No se pudo actualizar el carrito.'); });
  });

  /* ---------- Botones de cantidad (+ / −) ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty]');
    var input = wrap && $('input', wrap);
    if (!input) return;
    e.preventDefault();
    var min = parseInt(input.min || '0', 10);
    var val = (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-step'), 10);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Galería de producto ---------- */
  function initGallery(root) {
    var track = $('[data-gallery-track]', root);
    if (!track) return null;
    var slides = $$('[data-slide]', track);
    var thumbs = $$('[data-thumb]', root);
    var count = $('[data-gallery-count]', root);
    function setActive(i) {
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    function goTo(i) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
    setActive(0);
    return {
      goToMedia: function (id) {
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(id); });
        if (idx > -1) goTo(idx);
      }
    };
  }

  /* ---------- Variantes de producto ---------- */
  function initProduct(root) {
    var gallery = initGallery(root);
    var dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = document.getElementById(root.getAttribute('data-form-id'));
    var idInput = form && $('input[name="id"]', form);
    var addBtn = form && $('[data-add-btn]', form);
    var fieldsets = $$('[data-option-index]', root);

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = $('input:checked', fs);
        var select = $('select', fs);
        return checked ? checked.value : (select ? select.value : null);
      });
    }

    function markAvailability(selected) {
      fieldsets.forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var test = selected.slice();
          test[idx] = input.value;
          var ok = variants.some(function (v) {
            return v.available && v.options.every(function (o, k) { return o === test[k]; });
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
        var legendVal = $('[data-selected-value]', fs);
        if (legendVal) legendVal.textContent = selected[idx];
      });
    }

    function update() {
      var selected = selectedOptions();
      markAvailability(selected);
      var variant = variants.find(function (v) {
        return v.options.every(function (o, k) { return o === selected[k]; });
      });
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'No disponible'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      var now = $('[data-price-now]', root), was = $('[data-price-was]', root), priceWrap = $('[data-price]', root);
      if (now) now.textContent = formatMoney(variant.price);
      var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (was) { was.textContent = sale ? formatMoney(variant.compare_at_price) : ''; was.hidden = !sale; }
      if (priceWrap) priceWrap.classList.toggle('price--sale', !!sale);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.getAttribute('data-label') : 'Agotado';
      }
      if (variant.featured_media && gallery) gallery.goToMedia(variant.featured_media.id);
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });
    if (fieldsets.length) markAvailability(selectedOptions());
  }

  $$('[data-product]').forEach(initProduct);

  /* ---------- Compartir ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-url') || window.location.href;
    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { toast('Enlace copiado ✓'); });
    }
  });

  /* ---------- Productos recomendados ---------- */
  $$('[data-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = $('[data-recs]', tmp);
      if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      else el.closest('.shopify-section') && (el.closest('.shopify-section').hidden = true);
    }).catch(function () {});
  });

  /* ---------- Filtros de colección ---------- */
  $$('form[data-filters]').forEach(function (form) {
    form.addEventListener('change', function () {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
      window.location.search = params.toString();
    });
  });
  document.addEventListener('click', function (e) {
    $$('details.filter[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.classList || !d.classList.contains('filter') || !d.open) return;
    $$('details.filter[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
  }, true);

  window.ToyStore = { refreshCart: refreshCart, formatMoney: formatMoney, toast: toast };
})();
